import Vue from "vue";
import dayjs from "dayjs";
import it from "dayjs/locale/it";
import customParseFormat from "dayjs/plugin/customParseFormat";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(customParseFormat);
dayjs.extend(LocalizedFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

dayjs.locale(it);

Object.defineProperties(Vue.prototype, {
  $dayjs: {
    get() {
      return dayjs;
    }
  }
});
const InvalidReturn = "";

Vue.filter("dayjs", (value, method, ...params) => {
  let d = dayjs(value);
  if (!d.isValid()) return InvalidReturn;
  if (method) {
    return d[method].apply(d, params);
  }
});
